/*
 * B2B WhatsApp-first GA4 tracking template
 * Version: 2026-06-27
 *
 * This shared template intentionally contains no site-specific GA4, Ads, or
 * WhatsApp account identifiers. Configure each site before loading this file:
 */
  window.B2B_GA4_CONFIG = {
    measurementId: 'G-EHEXB2XRHH',
    sourcePlatform: 'shopify_theme',
    loadGtag: true,
    disableLocalPreview: true,
    rewriteWhatsAppLinks: true,
    contactPaths: ['/contact', '/pages/contact'],
    whatsappOpener: 'Hi, I am interested in your products and would like samples and a quote.',
    pageTypeMap: {
      home: [/^\/$/],
      product: [/^\/products\//],
      collection: [/^\/collections\//],
      contact: [/^\/contact$/, /^\/pages\/contact$/],
      blog: [/^\/blogs\//],
      search: [/^\/search/],
      landing_page: [/^\/pages\//]
    },
    clusterResolver: function () { return ''; },
    ads: {
      conversionId: '',
      conversions: {
        whatsapp: { label: '' },
        email: { label: '' },
        wechat: { label: '' },
        form: { label: '' }
      }
    },
    leadFunnel: {
      lead_intent: { stage: 'intent' },
      generate_lead: { stage: 'generated' }
    },
    formGuard: {
      enabled: true,
      honeypotSelector: 'input[name="contact[website]"], input[name="website"]',
      readyDelayMs: 2000,
      duplicateResetMs: 10000
    }
  };


(function () {
  'use strict';

  var cfg = window.B2B_GA4_CONFIG || {};
  var measurementId = cfg.measurementId || window.ga_measurement_id || '';
  var sourcePlatform = cfg.sourcePlatform || 'website';
  var GTAG_MAX_WAIT_MS = 5000;
  var GTAG_POLL_MS = 80;

  var defaults = {
    leadFunnel: {
      lead_intent: { stage: 'intent' },
      generate_lead: { stage: 'generated' }
    },
    adsConversions: {
      whatsapp: { label: '' },
      email: { label: '' },
      wechat: { label: '' },
      form: { label: '' }
    },
    formGuard: {
      enabled: true,
      honeypotSelector: 'input[name="contact[website]"], input[name="website"]',
      readyDelayMs: 2000,
      duplicateResetMs: 10000
    }
  };

  function warn(message) {
    if (window.console && console.warn) console.warn('[B2B GA4] ' + message);
  }

  function s(value) {
    return value == null ? '' : String(value).trim();
  }

  function mergeShallow(base, override) {
    var out = {};
    var key;
    for (key in base) out[key] = base[key];
    override = override || {};
    for (key in override) out[key] = override[key];
    return out;
  }

  function isLocalPreviewHost(hostname) {
    var host = s(hostname).toLowerCase();
    var configured = cfg.localPreviewHosts || [];
    if (configured.indexOf(host) !== -1) return true;
    return host === 'localhost' ||
      host === '0.0.0.0' ||
      host === '::1' ||
      host === '[::1]' ||
      /^127(?:\.\d{1,3}){3}$/.test(host) ||
      /^10(?:\.\d{1,3}){3}$/.test(host) ||
      /^192\.168(?:\.\d{1,3}){2}$/.test(host) ||
      /^172\.(1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2}$/.test(host);
  }

  if (cfg.disableLocalPreview !== false && isLocalPreviewHost(window.location.hostname)) {
    window.B2B_GA4_TRACKING_DISABLED = true;
    warn('local preview detected; tracking disabled for ' + window.location.hostname);
    return;
  }

  function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    if (!measurementId) {
      warn('measurementId is missing. Set window.B2B_GA4_CONFIG.measurementId before loading this file.');
      return;
    }

    if (cfg.loadGtag === false) return;

    var existing = document.querySelector('script[src*="googletagmanager.com/gtag/js?id=' + measurementId + '"]');
    if (existing) return;

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
    document.head.appendChild(script);
  }

  function waitForGtag(callback) {
    var elapsed = 0;
    function check() {
      if (typeof window.gtag === 'function') {
        callback();
        return;
      }
      elapsed += GTAG_POLL_MS;
      if (elapsed >= GTAG_MAX_WAIT_MS) {
        warn('gtag was not ready within ' + (GTAG_MAX_WAIT_MS / 1000) + ' seconds.');
        return;
      }
      setTimeout(check, GTAG_POLL_MS);
    }
    check();
  }

  function getUtmParams() {
    try {
      var params = new URLSearchParams(window.location.search);
      return {
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_content: params.get('utm_content') || '',
        utm_term: params.get('utm_term') || ''
      };
    } catch (error) {
      return {};
    }
  }

  function localeRoot() {
    var root = s(window.ga_locale_root);
    if (!root && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = s(window.Shopify.routes.root);
    }
    if (!root || root === '/') return '';
    if (root.charAt(0) !== '/') root = '/' + root;
    return root.replace(/\/+$/, '').toLowerCase();
  }

  function stripLocalePrefix(pathname) {
    var path = s(pathname || '/').toLowerCase();
    if (!path) path = '/';
    if (path.charAt(0) !== '/') path = '/' + path;
    var root = localeRoot();
    if (root && (path === root || path.indexOf(root + '/') === 0)) {
      path = path.slice(root.length) || '/';
    }
    if (path.length > 1) path = path.replace(/\/+$/, '');
    return path || '/';
  }

  function inferPageType(pathname) {
    var path = stripLocalePrefix(pathname || location.pathname || '/');
    var map = cfg.pageTypeMap || {
      home: [/^\/$/],
      product: [/^\/products\//],
      collection: [/^\/collections\//],
      contact: [/^\/contact\/?$/, /^\/pages\/contact\/?$/],
      blog: [/^\/blogs\//],
      search: [/^\/search/],
      landing_page: [/^\/pages\//]
    };

    for (var type in map) {
      var rules = map[type] || [];
      for (var i = 0; i < rules.length; i++) {
        if (rules[i] && rules[i].test && rules[i].test(path)) return type;
      }
    }
    return 'other';
  }

  function getClusterName() {
    try {
      if (typeof cfg.clusterResolver === 'function') return s(cfg.clusterResolver());
      var el = document.querySelector('[data-cluster]');
      if (el && el.getAttribute('data-cluster')) return s(el.getAttribute('data-cluster'));
      var meta = document.querySelector('meta[name="cluster"]');
      if (meta && meta.content) return s(meta.content);
    } catch (error) {}
    return '';
  }

  function baseParams() {
    var params = {
      page_location: location.href,
      page_referrer: document.referrer || '',
      page_title: document.title || '',
      page_type: inferPageType(location.pathname),
      content_cluster: getClusterName()
    };

    if (window.ga_country) params.country = s(window.ga_country);
    if (window.ga_language) params.language = s(window.ga_language);

    var utm = getUtmParams();
    Object.keys(utm).forEach(function (key) {
      if (utm[key]) params[key] = utm[key];
    });

    return params;
  }

  function fire(eventName, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, params || {});
    } catch (error) {
      if (window.console && console.error) console.error('[B2B GA4] event error:', error);
    }
  }

  function scopedLeadParams(params) {
    var source = params || {};
    var allowed = ['cta_channel', 'cta_position', 'cta_label', 'page_type', 'content_cluster', 'lead_stage'];
    var out = {};
    allowed.forEach(function (key) {
      if (source[key] !== undefined && source[key] !== null && s(source[key]) !== '') out[key] = s(source[key]);
    });
    if (!out.page_type) out.page_type = inferPageType(location.pathname);
    if (!out.content_cluster) out.content_cluster = getClusterName();
    return out;
  }

  function sendPageView() {
    fire('page_view', baseParams());
  }

  function isWhatsAppLink(href) {
    var value = s(href).toLowerCase();
    return value.indexOf('wa.me/') !== -1 ||
      value.indexOf('api.whatsapp.com') !== -1 ||
      value.indexOf('whatsapp.com/send') !== -1 ||
      value.indexOf('whatsapp://') === 0;
  }

  function isEmailLink(href) {
    return s(href).toLowerCase().indexOf('mailto:') === 0;
  }

  function isPhoneLink(href) {
    var value = s(href).toLowerCase();
    return value.indexOf('tel:') === 0 || value.indexOf('sms:') === 0;
  }

  function isWeChatLink(href) {
    var value = s(href).toLowerCase();
    return value.indexOf('weixin://') === 0 ||
      value.indexOf('wx.qq.com') !== -1 ||
      value.indexOf('weixin.qq.com') !== -1;
  }

  function isContactRouteLink(href) {
    var paths = cfg.contactPaths || ['/contact', '/pages/contact'];
    try {
      var url = new URL(href, location.origin);
      if (url.origin !== location.origin) return false;
      var path = stripLocalePrefix(url.pathname);
      return paths.indexOf(path) !== -1;
    } catch (error) {
      var clean = stripLocalePrefix(s(href).split(/[?#]/)[0]);
      return paths.indexOf(clean) !== -1;
    }
  }

  function inferPosition(el) {
    if (!el || !el.closest) return 'inline';
    if (el.closest('[data-cta-position]')) return s(el.closest('[data-cta-position]').getAttribute('data-cta-position')) || 'inline';
    if (el.closest('.floating-contact-sidebar')) return 'floating_sidebar';
    if (el.closest('.mobile-navigation-bar, .mobile-nav-whatsapp')) return 'mobile_menu';
    if (el.closest('.product-single, main .product, [data-product]')) return 'product_page';
    if (el.closest('.product-item, [data-product-card]')) return 'product_card';
    if (el.closest('footer, .footer')) return 'footer';
    if (el.closest('.hero, .slideshow, [class*="banner"]')) return 'hero';
    if (el.closest('.faq, .page-faqs')) return 'faq';
    if (el.closest('.rte, .page-content, .rich-text')) return 'inline_content';
    return 'inline';
  }

  function getAdsConversion(channel) {
    var ads = cfg.ads || {};
    var conversions = mergeShallow(defaults.adsConversions, ads.conversions || {});
    return conversions[channel] || null;
  }

  function getLeadFunnelConfig(eventName) {
    var funnel = mergeShallow(defaults.leadFunnel, cfg.leadFunnel || {});
    var eventCfg = funnel[eventName] || {};
    return {
      stage: eventCfg.stage || eventName
    };
  }

  function applyLeadFunnelParams(eventName, params) {
    var meta = getLeadFunnelConfig(eventName);
    params.lead_stage = params.lead_stage || meta.stage;
    return params;
  }

  function sendLeadFunnelEvent(eventName, params) {
    if (!defaults.leadFunnel[eventName]) return false;
    var eventParams = scopedLeadParams(params);
    applyLeadFunnelParams(eventName, eventParams);
    fire(eventName, eventParams);
    return eventParams;
  }

  var lastSig = '';
  var lastTs = 0;

  function dedupe(sig) {
    var now = Date.now();
    if (sig && sig === lastSig && now - lastTs < 1000) return true;
    lastSig = sig;
    lastTs = now;
    return false;
  }

  function markOnce(key) {
    if (!key) return true;
    try {
      if (window.sessionStorage && window.sessionStorage.getItem(key)) return false;
      if (window.sessionStorage) window.sessionStorage.setItem(key, '1');
      return true;
    } catch (error) {
      return !dedupe(key);
    }
  }

  function sendLeadIntent(intentType, params) {
    var eventParams = Object.assign({}, params || {});
    eventParams.cta_channel = eventParams.cta_channel || 'behavior';
    eventParams.cta_position = eventParams.cta_position || inferPageType(location.pathname);
    eventParams.cta_label = eventParams.cta_label || intentType || 'lead_intent';

    var key = [
      'b2b_ga4_lead_intent',
      eventParams.cta_label,
      location.pathname.toLowerCase(),
      eventParams.cta_channel,
      eventParams.cta_position
    ].join('|');

    return markOnce(key) ? sendLeadFunnelEvent('lead_intent', eventParams) : false;
  }

  function fireChannelEvent(channel, params) {
    var names = {
      whatsapp: 'whatsapp_click',
      email: 'email_click',
      wechat: 'wechat_click'
    };
    if (names[channel]) fire(names[channel], params);
  }

  function sendCta(channel, position, label, linkUrl) {
    var params = {};
    params.cta_channel = channel || 'other';
    params.cta_position = position || 'unknown';
    params.cta_label = label || 'cta_click';
    params.page_type = inferPageType(location.pathname);
    params.content_cluster = getClusterName();
    params = scopedLeadParams(params);

    fire('cta_click', params);
    fireChannelEvent(params.cta_channel, params);

    if (params.cta_channel === 'whatsapp' || params.cta_channel === 'email' || params.cta_channel === 'wechat') {
      sendLeadIntent('direct_contact_click', params);
    }

    return params;
  }

  function sendSecondaryEvent(eventName, channel, position, label, linkUrl) {
    var params = {};
    params.cta_channel = channel || 'other';
    params.cta_position = position || 'unknown';
    params.cta_label = label || eventName;
    params.page_type = inferPageType(location.pathname);
    params.content_cluster = getClusterName();
    params = scopedLeadParams(params);
    fire(eventName, params);
    return params;
  }

  function fireAdsConversion(channel, customParams) {
    var ads = cfg.ads || {};
    var conv = getAdsConversion(channel);
    if (!ads.conversionId || !conv || !conv.label) return;
    if (ads.conversionId.indexOf('AW-') !== 0) return;

    var payload = {
      send_to: ads.conversionId + '/' + conv.label,
      transaction_id: Date.now() + '_' + Math.random().toString(36).slice(2, 11)
    };

    if (customParams && customParams.user_data) payload.user_data = customParams.user_data;
    fire('conversion', payload);
  }

  function buildDefaultOpener() {
    var opener = cfg.whatsappOpener || 'Hi, I am interested in your products and would like samples and a quote.';
    var pageTitle = '';
    try {
      var h1 = document.querySelector('h1');
      pageTitle = s((h1 && h1.textContent) || document.title).replace(/\s+/g, ' ').slice(0, 100);
    } catch (error) {}
    if (pageTitle && opener.indexOf(pageTitle) === -1) opener += ' Page: ' + pageTitle + '.';
    return opener;
  }

  function buildTrackingTag() {
    var parts = [];
    try {
      var utm = getUtmParams();
      if (utm.utm_source) parts.push('UTM:' + utm.utm_source + '/' + (utm.utm_medium || '-') + '/' + (utm.utm_campaign || '-'));
      var slug = location.pathname.split('/').filter(Boolean).slice(-1)[0] || 'home';
      parts.push('Page:' + slug.slice(0, 40));
    } catch (error) {}
    return parts.length ? ' [' + parts.join(' | ') + ']' : '';
  }

  function rewriteWhatsAppLinks() {
    if (cfg.rewriteWhatsAppLinks === false) return;
    var links = document.querySelectorAll('a[href*="wa.me/"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]');
    var opener = buildDefaultOpener();
    var tag = buildTrackingTag();
    links.forEach(function (link) {
      if (link.dataset.b2bGa4WaTagged === '1') return;
      try {
        var url = new URL(link.href);
        var existing = url.searchParams.get('text');
        var text = existing && s(existing) ? existing : opener;
        if (text.indexOf('[Page:') === -1 && text.indexOf('[UTM:') === -1) text += tag;
        url.searchParams.set('text', text);
        link.href = url.toString();
        link.dataset.b2bGa4WaTagged = '1';
      } catch (error) {}
    });
  }

  function setupFormGuard() {
    var guard = mergeShallow(defaults.formGuard, cfg.formGuard || {});
    if (!guard.enabled) return;

    function setupForm(form) {
      if (!form || form.dataset.b2bGa4SpamGuardReady === 'true') return;
      form.dataset.b2bGa4SpamGuardReady = 'true';
      form.dataset.b2bGa4SpamGuardReadyAt = String(Date.now() + Number(guard.readyDelayMs || 0));
      form.addEventListener('submit', function (event) {
        var honeypot = form.querySelector(guard.honeypotSelector);
        var filled = honeypot && honeypot.value && honeypot.value.trim() !== '';
        var tooFast = Date.now() < Number(form.dataset.b2bGa4SpamGuardReadyAt || 0);
        var duplicate = form.dataset.b2bGa4SpamGuardSubmitting === 'true';
        if (filled || tooFast || duplicate) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return false;
        }
        form.dataset.b2bGa4SpamGuardSubmitting = 'true';
        setTimeout(function () {
          form.dataset.b2bGa4SpamGuardSubmitting = 'false';
        }, Number(guard.duplicateResetMs || 10000));
        return true;
      }, true);
    }

    function scan() {
      document.querySelectorAll(guard.honeypotSelector).forEach(function (input) {
        setupForm(input.closest('form'));
      });
    }

    scan();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function isSpamGuardBlocked(form) {
    var guard = mergeShallow(defaults.formGuard, cfg.formGuard || {});
    if (!guard.enabled || !form || !form.querySelector) return false;
    var honeypot = form.querySelector(guard.honeypotSelector);
    var filled = honeypot && honeypot.value && honeypot.value.trim() !== '';
    var tooFast = Number(form.dataset.b2bGa4SpamGuardReadyAt || 0) > Date.now();
    var duplicate = form.dataset.b2bGa4SpamGuardSubmitting === 'true';
    return Boolean(filled || tooFast || duplicate);
  }

  function attachClickTracking() {
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('a');
    var mobileWechatBtn = target.closest('[data-mobile-wechat-btn]');
    var cta = target.closest('.js-cta, [data-cta-channel]');

    if (link) {
      var href = s(link.getAttribute('href') || link.href);
      var position = s(link.getAttribute('data-cta-position')) || inferPosition(link);
      var label = s(link.getAttribute('data-cta-label')) || s(link.textContent) || position || 'cta_click';

      if (isWhatsAppLink(href)) {
        if (!dedupe('wa|' + href + '|' + position)) sendCta('whatsapp', position, label, href);
        return;
      }
      if (isEmailLink(href)) {
        if (!dedupe('email|' + href + '|' + position)) sendCta('email', position, label, href);
        return;
      }
      if (isWeChatLink(href)) {
        if (!dedupe('wechat|' + href + '|' + position)) sendCta('wechat', position, label, href);
        return;
      }
      if (isPhoneLink(href)) {
        if (!dedupe('phone|' + href + '|' + position)) {
          var phoneParams = sendSecondaryEvent('tel_click', 'phone', position, label, href);
          sendLeadIntent('direct_contact_click', phoneParams);
        }
        return;
      }
      if (isContactRouteLink(href)) {
        if (!dedupe('contact|' + href + '|' + position)) {
          var contactParams = sendSecondaryEvent('contact_route_click', 'contact_page', position, label, href);
          sendLeadIntent('contact_route_click', contactParams);
        }
        return;
      }
    }

    if (mobileWechatBtn) {
      var btnPosition = s(mobileWechatBtn.getAttribute('data-cta-position')) || 'mobile_menu';
      var btnLabel = s(mobileWechatBtn.getAttribute('data-cta-label')) ||
        s(mobileWechatBtn.getAttribute('aria-label')) ||
        s(mobileWechatBtn.textContent) ||
        'wechat_qr_button';

      if (!dedupe('mobile_wechat_btn|' + btnPosition + '|' + btnLabel)) {
        sendCta('wechat', btnPosition, btnLabel, '');
      }
      return;
    }

    if (cta) {
      var channel = s(cta.getAttribute('data-cta-channel'));
      var ctaPosition = s(cta.getAttribute('data-cta-position')) || inferPosition(cta);
      var ctaLabel = s(cta.getAttribute('data-cta-label')) || s(cta.textContent) || ctaPosition || 'cta_click';
      var linkUrl = cta.tagName === 'A' ? s(cta.getAttribute('href') || cta.href) : '';
      if (!dedupe('cta|' + channel + '|' + ctaPosition + '|' + ctaLabel)) sendCta(channel, ctaPosition, ctaLabel, linkUrl);
    }
  }, true);
}

  function attachFormTracking() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.tagName || form.tagName !== 'FORM') return;

      var action = s(form.action).toLowerCase();
      var id = s(form.id).toLowerCase();
      var className = s(form.className).toLowerCase();
      var isInquiry = action.indexOf('/contact') >= 0 ||
        id.indexOf('contact') >= 0 || id.indexOf('inquiry') >= 0 ||
        className.indexOf('contact') >= 0 || className.indexOf('inquiry') >= 0 ||
        form.hasAttribute('data-inquiry-form');

      if (!isInquiry || isSpamGuardBlocked(form)) return;

      var params = {};
      params.cta_channel = 'form';
      params.cta_position = 'inquiry_form';
      params.cta_label = id || 'contact_form';
      params.page_type = inferPageType(location.pathname);
      params.content_cluster = getClusterName();
      sendLeadIntent('form_submit_attempt', params);
    }, true);
  }

  function trackConfirmedFormSuccess() {
    document.querySelectorAll('[data-inquiry-success="true"]').forEach(function (marker) {
      var markerId = s(marker.getAttribute('data-inquiry-success-id')) || location.pathname.toLowerCase();
      var key = 'b2b_ga4_generate_lead|' + markerId;
      if (!markOnce(key)) return;
      sendLeadFunnelEvent('generate_lead', {
        cta_channel: 'form',
        cta_position: 'inquiry_form',
        cta_label: 'confirmed_form_success',
        page_type: inferPageType(location.pathname),
        content_cluster: getClusterName()
      });
    });
  }

  function scheduleEngagedIntent() {
    if (cfg.enableEngagedIntent === false) return;
    var type = inferPageType(location.pathname);
    if (['product', 'collection', 'landing_page', 'contact'].indexOf(type) === -1) return;

    var thresholdMs = Number(cfg.engagedIntentMs || 60000);
    var visibleMs = 0;
    var lastTs = Date.now();
    var fired = false;

    function updateVisibleTime() {
      var now = Date.now();
      if (document.visibilityState !== 'hidden') visibleMs += now - lastTs;
      lastTs = now;
    }

    function check() {
      if (fired) return;
      updateVisibleTime();
      if (visibleMs >= thresholdMs) {
        fired = true;
        sendLeadIntent('engaged_60s', {
          cta_channel: 'engagement',
          cta_position: type,
          cta_label: 'engaged_60s',
          engagement_seconds: Math.round(thresholdMs / 1000)
        });
        return;
      }
      setTimeout(check, 5000);
    }

    document.addEventListener('visibilitychange', updateVisibleTime);
    setTimeout(check, 5000);
  }

  function init() {
    ensureGtag();
    waitForGtag(function () {
      if (measurementId) {
        window.gtag('js', new Date());
        window.gtag('config', measurementId, { send_page_view: false });
      }

      sendPageView();
      rewriteWhatsAppLinks();
      setTimeout(rewriteWhatsAppLinks, 1500);
      setTimeout(rewriteWhatsAppLinks, 4000);
      setupFormGuard();
      attachClickTracking();
      attachFormTracking();
      trackConfirmedFormSuccess();
      scheduleEngagedIntent();

      window.sendCtaEvent = sendCta;
      window.sendLeadIntentEvent = sendLeadIntent;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

